
import { defineComponent } from "vue";

export default defineComponent({
	name: "CheckmarkSvg",
	props: {
		fill: {
			type: String,
			default: null as string | null,
		},
	},
});
